import script from "./trim-text-middle.vue?vue&type=script&setup=true&lang=ts"
export * from "./trim-text-middle.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__